// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2-BPk","alertIcon":"ConfirmModal_alertIcon__zIULW"};